export default class MB_Filter_Buttons {
    
    constructor(filters){
        this.filters = filters;
        this.buttons_init();
    }

    buttons_init(){

        this.filters.container.querySelectorAll('.mb_filter_buttons').forEach(container=>{
            
            let is_multiple = typeof container.dataset.filter_multiple !== 'undefined';

            this.filters.register_field(container);
            
            if( is_multiple ) {
                this.multiple_init(container);
            }
            else {
                this.single_init(container);
            }
        });

    }

    multiple_init(container){
        
        let key = container.dataset.filter_key;

        container.querySelectorAll('button').forEach(button=>{

            let filter_value = button.dataset.filter;
            
            button.addEventListener('click',()=>{
                let is_selected = button.classList.contains('selected');
                button.classList[!is_selected ? 'add' : 'remove']('selected');
                
                this.filters[!is_selected ? 'add_value' : 'remove_value'](key, filter_value);
                this.filters.apply();
            });
        })
        
    }

    single_init(container){

        let key = container.dataset.filter_key;
        let selected = null;
        
        container.querySelectorAll('button').forEach(button=>{
    
            let filter_value = button.dataset.filter;
            
            button.addEventListener('click',()=>{
                
                if( selected ) {
                    // unselect previous
                    selected.classList.remove('selected');
                }
                selected = button;
                selected.classList.add('selected');

                this.filters.set_value(key, filter_value);
                this.filters.apply();
            });
        })
    }

}